import React from 'react';
import ResultPageModal, { capitalizeTitle } from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModal';

function CondominioModal({
  insuranceRequest,
  addingQuote,
  quotations,
  selectQuotation,
  type,
  processingQuote,
}) {
  let title = capitalizeTitle(type.name);
  if (type.id === 'res_civile' && insuranceRequest.product.id === 1003) {
    title = 'Danni ai bene e RC terzi';
  } else if (type.id === 'assistenza' && insuranceRequest.product.id === 1003) {
    title = 'Assistenza';
  }

  return (
    <ResultPageModal
      type={type}
      title={title}
      insuranceRequest={insuranceRequest}
      addingQuote={addingQuote}
      quotations={quotations}
      selectQuotation={selectQuotation}
      processingQuote={processingQuote}
    />
  );
}

export default CondominioModal;
